<template>
  <div class="forgetWrapper">
    <el-dialog
      title="找回密码-重置密码"
      center
      :visible="dialogFormVisible"
      @close="closeDialog"
      class="dialogWidth"
    >
      <el-form :model="pwdForm">
        <el-form-item label="手机号码" :label-width="formLabelWidth">
          <el-input
            v-model.trim="pwdForm.PhoneNumber"
            auto-complete="off"
            placeholder="请输入手机号"
            style="width:80%"
          ></el-input>
        </el-form-item>
        <el-form-item label="验 证 码" :label-width="formLabelWidth">
          <el-input
            v-model="pwdForm.verification_code"
            auto-complete="off"
            placeholder="验证码"
            style="width:50%"
          ></el-input>
          <el-button
            type="primary"
            :disabled="!phoneRight"
            v-if="!countDown"
            @click="getVerifyCode"
          >获取验证码</el-button>
          <el-button v-else>已发送{{ countDown }}s</el-button>
        </el-form-item>
        <el-form-item label="新的密码" :label-width="formLabelWidth">
          <el-input
            v-model.trim="pwdForm.newPwd"
            auto-complete="off"
            placeholder="请输入新的密码"
            style="width:80%"
            type="password"
          ></el-input>
        </el-form-item>
        <div class="note">
          <i class="el-icon-message-solid" style="font-size:20px"></i>
          <span>手机号用来接收验证码信息，请认真填写！</span>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :disabled="successBtn"
          @click="confirmPurchase"
          style="width:50%;font-size:16px"
        >确认重置密码</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { phoneMsg, confirmPurchase, updateForgetPwd } from "../../api/index";
import bcryptjs from "bcryptjs";
export default {
  props: {
    dialogFormVisible: {
      type:Boolean,
      default: false
    }
  },
  data() {
    return {
      pwdForm: {
        PhoneNumber: null, //手机号
        verification_code: null, //验证码
        newPwd: null
      },
      formLabelWidth: "120px",
      countDown: 0, //倒计时
      successBtn: true,
      module:{},
      codeid:null,//临时用来保存后台返回的验证码ID
    };
  },
  computed: {
    //验证手机号是否合理
    phoneRight() {
      return /^1[3-8][0-9]{9}$/.test(this.pwdForm.PhoneNumber);
    }
  },
  methods: {
    closeDialog(event) {
      this.pwdForm.PhoneNumber = null;
      this.pwdForm.verification_code = null;
      this.countDown = 0;
      this.successBtn = true;
      clearInterval(this.intervalId);
      this.$emit("closedialog",false)
    },
    async getApiIndexMethod(){
      const flag=this.$apiFlag;
      if(flag===1||flag===3){
        this.module=await import("../../api/index");
      }else if(flag===2){
        this.module=await import("../../api/index22");
      }
    },
    //获取验证码
    async getVerifyCode() {
      if (!this.phoneRight) {
        this.$message.error("请输入正确的手机号码");
        return;
      } else {
        this.countDown = 60;
        //设置定时器
        this.intervalId = setInterval(() => {
          this.countDown--;
          if (this.countDown === 0) {
            clearInterval(this.intervalId);
          }
        }, 1000);
      }
      //获取后台验证码
      // const result = await phoneMsg(this.pwdForm.PhoneNumber);
      const result = await this.module.phoneMsg(this.pwdForm.PhoneNumber);
      if (result.data.code === 200) {
        this.successBtn = false
        this.codeid = result.data.data
        this.$message({
          message: result.data.msg,
          type: "success"
        });
      }else if(result.data.code===500){
            if(result.data.message){
                this.$message({message:result.data.message,type:'error'});
            }else if(result.data.msg){
              this.$message({message:result.data.message,type:'error'});
            }
      }else if(result.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(result.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(result.status===409||result.status===410||result.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      } else {
        this.$message.error(result.msg);
      }
    },
    async confirmPurchase() {
      if (!this.pwdForm.PhoneNumber) {
        this.$message.error("请输入正确的手机号码");
        return;
      }else if (!this.pwdForm.verification_code) {
        this.$message.error("请输入验证码");
        return;
      }else if (!this.pwdForm.newPwd) {
        this.$message.error("请输入新的密码");
        return;
      }
      // const codeid="ace0db60-a886-4be6-befb-6c12794dcb98";
      // 验证用户输入验证码是否正确
      // const codeResult = await confirmPurchase(this.codeid,this.pwdForm.verification_code,this.pwdForm.PhoneNumber)
      const codeResult = await this.module.confirmPurchase(this.codeid,this.pwdForm.verification_code,this.pwdForm.PhoneNumber)
      if (codeResult.data.code === 200) {
        const salt =bcryptjs.genSaltSync(10);
        const password = bcryptjs.hashSync(this.pwdForm.newPwd,salt);
        // this.$md5(this.pwdForm.newPwd)
        let user = {phone: this.pwdForm.PhoneNumber, password: password}
        await this.module.updateForgetPwd(user).then(async res=>{
          if (res.data.code === 200) {
             this.$message({
              message: "重置密码成功",
              type: "success"
            });
          this.$emit("closedialog",false)
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }else if(res.data.msg){
              this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        } else {
            this.$message.error("重置密码失败");
          }
        })
      }else if(codeResult.data.code===500){
            if(codeResult.data.message){
                this.$message({message:codeResult.data.message,type:'error'});
            }else if(codeResult.data.msg){
              this.$message({message:codeResult.data.message,type:'error'});
            }
      }else if(codeResult.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(codeResult.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(codeResult.status===409||codeResult.status===410||codeResult.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      } else {
        this.$message.error("验证码错误");
      }
    }
  },
  async mounted(){
    await this.getApiIndexMethod();
  }
};
</script>

<style lang="stylus" scoped> 
.dialogWidth
  margin 0 auto
  .note 
    margin-left 50px
    color #ff5a00
    span 
      padding-left 5px

@media screen and (min-width:960px) and (max-width:1920px)
  .dialogWidth
    width 60vw    
@media screen and (max-width:1280px)
  .dialogWidth
    width 80vw    
</style>